import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Search, User, Bell, SlidersHorizontal } from "lucide-react";
import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function Header() {
  const { user } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const [q, setQ] = useState("");
  const [unread, setUnread] = useState(0);

  useEffect(() => {
    const u = new URLSearchParams(location.search).get("q") || "";
    setQ(u);
  }, [location.search]);

  useEffect(() => {
    if (!user) return;
    api.get("/notifications/unread-count").then(r => setUnread(r.data.count || 0)).catch(() => {});
  }, [user, location.pathname]);

  const onSearch = (e) => {
    e.preventDefault();
    nav(`/recherche?q=${encodeURIComponent(q.trim())}`);
  };

  const openFilters = () => {
    const sp = new URLSearchParams(location.search);
    sp.set("open_filters", "1");
    if (q.trim()) sp.set("q", q.trim());
    nav(`/recherche?${sp.toString()}`);
  };

  const showSearchBar = location.pathname === "/" || location.pathname.startsWith("/recherche");

  return (
    <>
      {/* Row 1 — logo + FORUM CI + notifications + account : NON sticky, disparaît au scroll */}
      <div className="bg-white/95 backdrop-blur-md">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 pt-2.5 sm:pt-3 pb-2">
          <div className="flex items-center gap-3">
            <Link to="/" data-testid="logo-link" className="flex items-center gap-2.5 shrink-0">
              <div className="w-11 h-11 rounded-xl bg-[#E65100] flex items-center justify-center shadow-sm">
                <span className="text-white font-extrabold text-xl font-[Manrope]">F</span>
              </div>
              <div className="leading-none">
                <div className="font-extrabold text-[#1A1918] text-base sm:text-lg font-[Manrope] tracking-tight">FORUM CI</div>
                <div className="text-[10px] sm:text-[11px] text-[#73706B] mt-1 uppercase tracking-wider font-semibold">
                  Marketplace Côte d'Ivoire
                </div>
              </div>
            </Link>

            <div className="flex-1" />

            {user && (
              <Link to="/notifications" data-testid="nav-notifications" className="relative w-10 h-10 rounded-xl border border-[#E8E6E1] flex items-center justify-center hover:border-[#E65100] transition">
                <Bell className="h-5 w-5 text-[#1A1918]" />
                {unread > 0 && (
                  <span className="absolute -top-1 -right-1 h-5 min-w-5 px-1 rounded-full bg-[#E65100] text-white text-[10px] font-bold flex items-center justify-center">
                    {unread > 9 ? "9+" : unread}
                  </span>
                )}
              </Link>
            )}
            <Link to={user ? "/profil" : "/connexion"} data-testid="nav-account" className="w-10 h-10 rounded-xl bg-[#1A1918] text-white flex items-center justify-center hover:bg-[#E65100] transition shrink-0">
              <User className="h-5 w-5" />
            </Link>
          </div>
        </div>
      </div>

      {/* Row 2 — Search + Filter : STICKY, reste en haut au scroll (affiché uniquement sur Accueil + Recherche) */}
      {showSearchBar && (
        <div className="sticky top-0 z-40 bg-white/95 backdrop-blur-md border-b border-[#E8E6E1]">
        <div className="max-w-7xl mx-auto px-3 sm:px-6 py-2.5">
          <form onSubmit={onSearch} className="flex items-center gap-2" data-testid="header-search-form">
            <div className="relative flex-1">
              <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-[#73706B]" />
              <input
                data-testid="header-search-input"
                value={q}
                onChange={(e) => setQ(e.target.value)}
                placeholder="Que recherchez-vous ?"
                className="w-full h-11 pl-9 pr-3 rounded-xl border border-[#E8E6E1] bg-[#FCFCF9] text-sm focus:outline-none focus:ring-2 focus:ring-[#E65100]/20 focus:border-[#E65100] transition"
              />
            </div>
            <button
              type="button"
              data-testid="header-filter-btn"
              onClick={openFilters}
              className="shrink-0 h-11 px-3 rounded-xl border border-[#E8E6E1] bg-white text-[#1A1918] hover:border-[#E65100] hover:text-[#E65100] transition inline-flex items-center gap-1.5 font-semibold text-sm"
            >
              <SlidersHorizontal className="h-4 w-4" />
              Filtres
            </button>
          </form>
        </div>
      </div>
      )}
    </>
  );
}
